<template>
  <div id="app">
    <meta name="referrer" content="no-referrer" />
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    // 先检查sessionStorage中是否有数据，若存在数据则加载到vuex
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  // 组件销毁阶段，解除监听返回按钮的事件
  destroyed() {
    window.removeEventListener("popstate", this.onCloseModal, false);
  },
  mounted() {
    // 监听浏览器的返回按钮
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.onCloseModal, false);
    }
    
  },
  methods: {

  },
};
</script>
>
<style lang="scss">
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html {
  overflow: hidden;
}
#app {
  width: 100vw;
  height: 100vh;
}
.el-dialog {
  width: 49vw !important;
  height: 91vh !important;
  margin: 0 auto;
  z-index: 100;
  margin-top: 3vh !important;
  background: url("assets/tan.png") no-repeat !important;
  background-size: 100% 100% !important;
  background-color: none !important;
}
.el-dialog__body {
  padding: 22px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 17;
  -webkit-box-orient: vertical;
}

</style>
